export default "__VITE_ASSET__DJx8DDNH__"